// extracted by mini-css-extract-plugin
module.exports = {"title":"title--729VL","foooterBtn":"foooterBtn--vgyWe","btnItem":"btnItem--k8G2a"};